import * as React from "react";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {BackButton} from "../../../../../components/navigation/BackButton";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import {getSessionStorage} from "../../../../../CommonFunctions";
import {RouteComponentProps} from "react-router-dom";
import {Button} from "reactstrap";
import {CLAIM_TYPE_HOME, FalconNavigatorHeader} from "@falcon/services";

interface IPageParams {
    policyNumber: string;
}

interface IProps extends RouteComponentProps<IPageParams> {
    location: any;
}

export class ClaimDetailsPage extends React.Component<IProps> {

    constructor(props: IProps) {
        super(props);
    }

    public render() {
        const claim: string = getSessionStorage("claim");
        const referrerJourney: string = getSessionStorage("referrerJourney");
        const backLink: string = referrerJourney === 'newClaim'
            ? `/dashboard/annualHome/${this.props.match.params.policyNumber}/claims/new`
            : `/dashboard/annualHome/${this.props.match.params.policyNumber}`;
        const claimTitle = (claim === CLAIM_TYPE_HOME)
            ? "Home Emergency Claim Reporting"
            : "All other home claims";
        const hideOnlineClaims: boolean = process.env.REACT_APP_HOME_HIDE_ONLINE_CLAIMS ? (process.env.REACT_APP_HOME_HIDE_ONLINE_CLAIMS.toString() === "true") : false;
        return (
            <React.Fragment>
                <FalconHeader/>
                <div className="page-contents dashboard-page">
                    <FalconNavigatorHeader
                        back={backLink}
                        title={claimTitle}
                    />
                    <div className="panel claim-page">
                        <div className="my-4 font-weight-bold claim-text">
                            {claim === CLAIM_TYPE_HOME
                                ? this.renderHomeEmergencyClaimContent(hideOnlineClaims)
                                : this.renderOtherClaimContent(hideOnlineClaims)
                            }

                            <p>
                                Lines open <span className="font-weight-semi-bold">24 hours, 7 days a week.</span>{' '}
                                Calls will be recorded. For Text Phone, first dial 18001
                            </p>
                        </div>
                        <BackButton isTop={false}
                                    link={backLink}/>
                    </div>
                </div>
                <FalconFooter/>
            </React.Fragment>
        );
    }

    private renderHomeEmergencyClaimContent(hideOnlineClaims: boolean): JSX.Element {
        if (hideOnlineClaims) {
            return (
                <>
                    <p>To report a home emergency claim get in touch with us.
                    </p>
                    <p className="mt-4">Our 24 hour helpline</p>
                    <a href="tel:+44 0330 678 5239"
                       className="no-underline font-weight-semi-bold icon-phone-before"
                       id="claimsPagePhoneLinkAbroad" aria-label="Phone number +44 0330 678 5239">
                        0330 678 5239
                    </a>
                </>
            )
        } else {
            return (
                <>
                    <p>To report a home emergency claim get in touch with us.
                        You can log a claim online by using the button below. It’s simple and quick!
                    </p>
                    <Button className="my-3" color="btn btn-primary"
                            href={`${process.env.REACT_APP_HOME_EMERGENCY_CLAIM_URL}`}>Log a Home Emergency
                        claim</Button>
                    <p className="mt-4">Or call us on our 24 hour helpline</p>
                    <a href="tel:+44 0330 678 5239"
                       className="no-underline font-weight-semi-bold icon-phone-before"
                       id="claimsPagePhoneLinkAbroad" aria-label="Phone number +44 0330 678 5239">
                        0330 678 5239
                    </a>
                </>)
        }
    }

    private renderOtherClaimContent(hideOnlineClaims: boolean): JSX.Element {
        if (hideOnlineClaims) {
            return (
                <>
                    <a href="tel:0330 678 5000"
                       className="no-underline font-weight-semi-bold icon-phone-before"
                       id="claimsPagePhoneLink"
                       aria-label="Phone number 0330 678 5000">
                        0330 678 5000
                    </a>
                    <p>Lines open <b>24 hours, 7 days a week.</b> Calls will be recorded. For Text Phone, first dial
                        18001</p>
                    <p className="mt-4">From abroad</p>
                    <a href="tel:+44 01202 295398"
                       className="no-underline font-weight-semi-bold icon-phone-before"
                       id="claimsPagePhoneLinkAbroad" aria-label="Phone number +44 01202 295398">
                        (+44) 01202 295398
                    </a>
                </>
            )
        } else {
            return (
                <>
                    <p>It’s simple and quick to report a home claim using the button below.
                        Log your claim by 3pm (Mon-Fri) and we’ll reply by the end of the day or by the end of the next
                        working day if logged later.
                        Sometimes in extreme weather and busy time it can take a little longer - please bear with us!
                    </p>
                    <Button className="my-3" color="btn btn-primary"
                            href={`${process.env.REACT_APP_HOME_OTHER_CLAIM_URL}` + '?journey=digital&policy=' + `${this.props.match.params.policyNumber}`}>Log
                        a Home claim</Button>
                    <p className="mt-4">If it’s urgent, just give us a call</p>
                    <a href="tel:0330 678 5000"
                       className="no-underline font-weight-semi-bold icon-phone-before"
                       id="claimsPagePhoneLink"
                       aria-label="Phone number 0330 678 5000">
                        0330 678 5000
                    </a>
                    <p>Lines open <b>24 hours, 7 days a week.</b> Calls will be recorded. For Text Phone, first dial
                        18001</p>
                    <p className="mt-4">From abroad</p>
                    <a href="tel:+44 01202 295398"
                       className="no-underline font-weight-semi-bold icon-phone-before"
                       id="claimsPagePhoneLinkAbroad" aria-label="Phone number +44 01202 295398">
                        (+44) 01202 295398
                    </a>
                </>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/annual/home/claims/ClaimDetailsPage.tsx